import { createComponent } from '@carvana/merch-components';
import { cvBreakpoint1024, cvBreakpoint768 } from '@carvana/theme';
import styled, { keyframes } from 'styled-components';

const fromTop = keyframes`
    0% {
      top: -68px;
    }

    100% {
      top: 0px;
    }
  `;

export const StickyWrapper = styled.div.attrs({
  className: 'flex flex-col pb-16 px-16 top-0 w-full z-[1] m:p-0',
  'data-qa': 'search-bar'
})`
  &.is-sticky {
    justify-content: center;
    align-items: center;
    transition: top 0.5s ease-in-out;
    position: sticky;
    padding-top: 16px;
    box-shadow: 0px 3px 6px -2px rgba(25, 41, 61, 0.18);
    background: #00619e;
    border: none;
    animation: ${fromTop} 0.5s ease-in-out;
    z-index: 2;

    @media (min-width: ${cvBreakpoint768}px) {
      padding: 16px 32px;
      top: 0;
    }

    @media (min-width: ${cvBreakpoint1024}px) {
      justify-content: space-between;
    }
  }
`;

export const Header = styled.div.attrs({
  className: 'gap-x-12 grid grid-cols-[1fr_auto] pb-16 px-0 w-full'
})`
  &.is-sticky {
    display: none;
  }
`;

export const Input = createComponent('input', {
  className: 'bg-grey-1 border-0 text-ellipsis tl-body-s m:tl-body-m',
  'data-qa': 'search-bar-input'
});

export const SearchToolsContainer = createComponent('div', {
  className:
    'bg-grey-1 gap-x-16 grid grid-cols-[1fr_auto] items-center pt-16 px-16 m:bg-white m:p-0'
});

export const SortSaveSearch = styled.div.attrs({
  className: 'gap-x-16 grid tl-header-xs m:gap-x-24 m:tl-header-s'
})`
  grid: auto / repeat(3, auto);
`;

export const IconWithTextWrapper = createComponent('div', {
  className: 'gap-x-8 grid grid-cols-[auto_1fr] items-center'
});

export const Bar = createComponent('div', {
  className: 'border-0 border-grey-2 border-l-2 border-solid h-[20px]'
});

export const SearchInputWrapper = createComponent('div', {
  className: 'flex flex-row h-[47px] justify-between relative w-full m:h-[57px]'
});
